import React, { Component } from 'react';
import { Link } from "react-router-dom";
import './fullWidthPortfolioTeaser.css';
import ScrollFadeIn from './../scrollFadeIn';
import { withController, Parallax } from 'react-scroll-parallax';

class FullWidthPortfolioTeaser extends Component {
  render() {
    return (
      <ScrollFadeIn>
        <div className={"full-width-portfolio-teaser-container background-image-fill "+this.props.direction} style={{backgroundImage:"url("+this.props.backgroundImage+")"}}>
          <div className="full-width-portfolio-teaser-card-container">
            <Parallax y={[-10, 10]}>
              <div className="full-width-portfolio-teaser-card">
              {this.props.icon && <img alt="" className="full-width-portfolio-teaser-logo" src={this.props.icon} />}
              <h6 className="full-width-portfolio-teaser-subtitle primary-color" style={{'marginTop':'0px', textTransform:"uppercase"}}>{this.props.subtitle}</h6>
              <h2 className="full-width-portfolio-teaser-title" style={{marginLeft:"-.15%"}}>{this.props.title}</h2>
              <p className="full-width-portfolio-teaser-description">{this.props.description}</p>
              <Link to={this.props.link}>
                <div className="full-width-portfolio-teaser-button"></div>
              </Link>
              </div>
            </Parallax>
          </div>
        </div>
      </ScrollFadeIn>
    );
  }
}

export default withController(FullWidthPortfolioTeaser);



// WEBPACK FOOTER //
// ./src/components/fullWidthPortfolioTeaser/index.js